import { ButtonGeneral, CheckboxLabelled, typographyRem } from '@by-miles/bymiles-styles'
import { DataLayer } from '@by-miles/data-layer'
import React, { useContext, useEffect, useState } from 'react'

import { ProviderContext } from '../../../../../Provider'
import { GenericOverlay } from '../../../../Overlays'
import { AdditionalDriversStyle } from '../AdditionalDriversStyle'
const { h2: H2, paragraphBody: ParagraphBody } = typographyRem

interface AddDriverConsentModalProps {
  onClick: () => void
}

export const AddDriverConsentModal = ({ onClick }: AddDriverConsentModalProps) => {
  const { handleCloseModal } = useContext(ProviderContext)

  const [error, setError] = useState<string>('')
  const [checked, setChecked] = useState<boolean>(false)

  const handleConfirmConsent = () => {
    if (checked) {
      onClick()
      DataLayer.customEvent({
        eventName: 'add drivers - complete-consent',
        section: 'additional driver',
        eventType: 'form tracking',
      })
      handleCloseModal('driver-consent')
    } else {
      setError('You must agree to these terms to continue.')
    }
  }

  const handleLinkClick = (target: string) => {
    window.open(`https://www.bymiles.co.uk/${target}`, '_blank')?.focus()
  }

  useEffect(() => {
    setError('')
  }, [checked])

  return (
    <AdditionalDriversStyle>
      <GenericOverlay
        onClose={() => handleCloseModal('driver-consent')}
        overlay={
          <>
            <H2>Add additional driver.</H2>
            <div className="modal-info-container">
              <ParagraphBody className="modal-info">
                I have explained the requirements of the policy with any additional drivers and they have read and
                accepted the{' '}
                <span onClick={() => handleLinkClick('privacy-policy')} className="modal-link">
                  privacy notice
                </span>
                {' and '}
                <span onClick={() => handleLinkClick('terms-of-business')} className="modal-link">
                  terms of business
                </span>
                .
              </ParagraphBody>
              <ParagraphBody className="modal-info">
                All additional drivers have agreed to share their personal telematics data with me, the policyholder.
              </ParagraphBody>
              <div className="checkbox-container">
                <CheckboxLabelled
                  label="I agree that all the above is correct."
                  dataCy="additional-driver-consent-checkbox"
                  value={checked}
                  onClick={(value: boolean) => setChecked(!value)}
                  error={error}
                />
              </div>
            </div>
            <ButtonGeneral
              iconRight="IconCaretRight"
              label="Add driver"
              onClick={handleConfirmConsent}
              dataCy="confirm-additional-driver-consent"
              className="modal-button"
            />
          </>
        }
      />
    </AdditionalDriversStyle>
  )
}
